import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CallStatus } from '@ngrx-traits/signals';
import { ContentContainerComponent } from '@shared/preloader';
import { PreviewSelectionComponent } from '../helper/preview/preview.component';
import { getFormlyFieldValue } from '../../utils/formlyfield.helper';

@Component({
    selector: 'kt-formly-field-selection',
    templateUrl: './selection.component.html',
    styleUrl: './selection.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ContentContainerComponent,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatIconModule,
        PreviewSelectionComponent,
    ]
})
export class FormlyFieldSelectionComponent extends FieldType<FieldTypeConfig> {
  readonly callStatus = signal<CallStatus>('init');

  get visible() {
    // Read via getFormlyFieldValue: a Formly Repeat (fieldArray) field has no
    // formControl in the read-only panel, so its value comes from the model.
    const value = getFormlyFieldValue(this.field);
    return Array.isArray(value) ?
      value.filter(Boolean).length > 0 :
      value !== undefined && value !== null;
  }

  removeSelection(value: any): void {
    if (Array.isArray(this.formControl.value)) {
      this.formControl.setValue(this.formControl.value.filter((v: any) => v !== value));
    } else {
      this.formControl.setValue(undefined);
    }
  }
}
